<div class="custom-select">
  <p *ngIf="filterTitle" class="custom-select__title">
    {{ 'FILTERS.' + filterTitle | translate }}
  </p>
  <div class="custom-select__block">
    <p (click)="openSelect($event)" class="custom-select__block-current">
      <ng-container *ngIf="!selectedValue">{{
        'FILTERS.NOT_SET' | translate
      }}</ng-container>
      <ng-container *ngIf="selectedValue">{{ selectedValue }}</ng-container>
    </p>
    <ul
      [class.active]="isOpenSelectList"
      class="custom-select__block-list active"
    >
      <li *ngFor="let item of filter" (click)="selectItem(item)" class="item">
        {{ item.description }}
      </li>
    </ul>
  </div>
</div>
